export default __webpack_public_path__ + "static/media/hsgLogo.641199c6.png";